import './index.css'
import './app-theme.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { checkAccountSession, getSnapshot, subscribe } from './lib/session'

// Never retry a failed read silently forever; show the error and the last good copy.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: true },
    mutations: { retry: false },
  },
})

// Account builds (0022): forget a remembered person whose session is gone, and drop every
// cached read when the signed-in identity changes, so nothing of one person's is shown to
// the next on a shared device.
void checkAccountSession()
let lastIdentity = getSnapshot().identityKey
subscribe(() => {
  const next = getSnapshot().identityKey
  if (getSnapshot().accountMode && next !== lastIdentity) queryClient.clear()
  lastIdentity = next
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
